import { Link } from "react-router-dom";

import { navigationFooter } from "../../consts";

import { classNames } from "../../../../shared/lib/classNames";
import { FC } from "react";

import styles from "./FooterNav.module.scss";

interface FooterNavProps {
    className?: string;
}

const links = navigationFooter.map(({ name, to }) => (
    <li key={name} className={styles.listItem}>
        <Link to={to}>
            {name}
        </Link>
    </li>
));

const FooterNav: FC<FooterNavProps> = ({ className }) => (
    <ul
        className={classNames({
            cls: styles.list,
            additional: [className],
        })}
    >
        {links}
    </ul>
);

export default FooterNav;
